import React from 'react'
import "./styles.css"

import TextBox from "components/TextBox";
import Button from "components/UI/Button";
import { API_URL } from "config/constants";
import { decimalFilter } from 'common/Utils'

import update from 'immutability-helper';
import axios from "axios";
import { toast } from "react-toastify";
import Select from "react-select";

class AddForm extends React.Component {

    state = {
        entries : [
            {}
        ]
    }
    
    render () {
        return (
            <React.Fragment>
                <div>
                    {this.renderEntries()}
                    {this.addNewEntry()}
                </div>
                {this.renderSendButton()}
            </React.Fragment>
        )
    }

    renderTableHeaders = () => 
        <div className="entry">
            <div className="entry-title">Trainer Name</div>
            <div className="entry-title">Trainer Email</div>
            <div className="entry-title">Rate</div>
            <div className="entry-title">Gyms</div>
            <div style={{width:24, height:24}}></div>
        </div>

    renderEntries = () => {
        if (this.state.entries.length === 0) {
            return (
                <div>
                    <TrainerEntry gyms={this.props.gyms} hideRemove/>
                </div>
            )
        } else {
            return (
                <div>
                    {
                        this.state.entries.map(({name, email, rate, gyms}, index)=>
                            <TrainerEntry
                                key={index}
                                index={index}
                                hideRemove={this.state.entries.length === 1}
                                name={name}
                                email={email}
                                rate={rate}
                                selectedGyms={gyms}
                                gyms={this.props.gyms}
                                onNameChange={(name)=>{
                                    const entry = this.state.entries[index]
                                    entry.name = name
                                    const newEntries = update(this.state.entries, {[index]: {$set: entry}}) 
                                    this.setState({
                                        entries:newEntries
                                    })
                                }}
                                onEmailChange={(email)=>{
                                    const entry = this.state.entries[index]
                                    entry.email = email
                                    const newEntries = update(this.state.entries, {[index]: {$set: entry}}) 
                                    this.setState({
                                        entries:newEntries
                                    })
                                }}
                                onRateChange={(rate)=>{
                                    const entry = this.state.entries[index]
                                    entry.rate = rate
                                    const newEntries = update(this.state.entries, {[index]: {$set: entry}}) 
                                    this.setState({
                                        entries:newEntries
                                    })
                                }}
                                onGymListChange={(gyms)=> {
                                    const entry = this.state.entries[index]
                                    entry.gyms = gyms
                                    const newEntries = update(this.state.entries, {[index]: {$set: entry}}) 
                                    this.setState({
                                        entries:newEntries
                                    })
                                }}
                                onRemove={(i)=>{
                                    const entries = this.state.entries.filter((val, ind) => i !== ind)
                                    this.setState({
                                        entries
                                    })
                                }}
                            />
                        )
                    }
                </div>
            );
        }
    }

    addNewEntry = () =>
        <div className="entry" style={{marginTop:15}} onClick={()=>{
            const entries = this.state.entries;
            entries.push({})
            this.setState({
                entries
            })
        }}>
            <img src={require('assets/images/add.svg')} alt={"add"}></img>
            <div className="add-label">Add additional trainer</div>
        </div>

    renderSendButton = () => 
        <div style={{alignSelf:'stretch', justifyContent:'center', alignItems:'center'}}>
            <Button 
                style={{marginTop: "30px", width: "230px"}}
                type="primary"
                grey={this.filter().length <= 0}
                onClick={this.sendInvites}>
                Send Invitations
            </Button>
        </div>

    filter = () => {
        const validEntries = this.state.entries.filter((val)=> {
            return (val.name && val.email && val.rate && val.gyms && val.gyms.length > 0)
        })
        return validEntries
    }

    sendInvites = () => {
        var entries = this.filter()
        if (entries.length <= 0) return;
        var trainers = {};
        entries.forEach((val)=>{
            var trainer = JSON.parse(JSON.stringify(val))
            var gyms = trainer.gyms.map(gym => gym.value)
            if(trainers[trainer.email]) {
                trainers[trainer.email].gyms.forEach(gym=>{
                    if(!gyms.includes(gym))
                        gyms.push(gym)
                })
            } 
            trainer.gyms = gyms;
            trainers[trainer.email] = trainer;
        })
        const access_token = localStorage.getItem("access_token");
        axios.post(`${API_URL}/trainer/register_bulk`, {
            trainers: trainers
        }, {
            headers: {
                "x-access-token": access_token
            }
        }).then(res => {
            this.setState({
                entries: [
                    {}
                ]
            })
            toast.success("Invitations sent successfully", { autoClose: 2000 });
        }).catch(error => {
            toast.error("Invitation failed", { autoClose: 2000 });
        })
    }
}

class TrainerEntry extends React.Component{
    
    state = {
        name: "",
        email: "",
        rate: "",
        selectedGyms: []
    }

    componentWillReceiveProps(newProps) {
        this.setState({
            name: newProps.name ? newProps.name : "",
            email: newProps.email ? newProps.email : "",
            rate: newProps.rate ? newProps.rate : "",
            selectedGyms: newProps.selectedGyms ? newProps.selectedGyms : []
        })
    }

    render() {
        return (
            <div className="entry">
                <TextBox
                    style={{
                        width: "200px"
                    }}
                    placeholder={"First name"}
                    defaultValue={this.props.name}
                    value={this.state.name}
                    onChange={(event)=>{
                        this.setState({
                            name: event.target.value
                        })
                        this.props.onNameChange(event.target.value)
                    }}
                />
                <TextBox
                    style={{
                        width: "200px"
                    }}
                    placeholder={"Email"}
                    defaultValue={this.props.email}
                    value={this.state.email}
                    onChange={(event)=>{
                        this.setState({
                            email: event.target.value
                        })
                        this.props.onEmailChange(event.target.value)
                    }}
                />
                <TextBox
                    style={{
                        width: "70px"
                    }}
                    placeholder={"Rate $"}
                    defaultValue={this.props.rate}
                    value={this.state.rate}
                    type="number"
                    onChange={(event)=>{
                        var value = event.target.value;
                        if (!isNaN(value) && decimalFilter(value, 2)) {
                            this.setState({
                                rate: value
                            })
                            this.props.onRateChange(value)
                        }
                    }}
                />
                <Select
                    styles={{
                        container: (base) => ({
                          ...base,
                          display: 'flex',
                          width: '300px',
                        }),
                        control: (base, state) => {
                          return {
                            ...base,
                            boxShadow: state.isFocused ? "0 0 3px 2px rgba(0,180,210,0.38)" : 0,
                            "&:hover": {
                                borderColor: state.isFocused ? 'rgba(0,180,210,1)' : 'black'
                            },
                            border: state.isFocused ? "1px solid rgba(0,180,210,1)" : "1px solid black",
                            borderRadius: "6px",
                            padding: "2px",
                            display: 'flex',
                            marginRight: "10px",
                            height: '48px',
                            width: '300px',
                            overflowX: 'auto',
                            scrollbarWidth: '1px'
                          };
                        },
                        multiValueLabel : (base) => {
                            return {
                                ...base,
                                backgroundColor: 'rgba(255,255,255,0.8)'
                            }
                        },
                        valueContainer:  (base) => {
                            return {
                                ...base,
                                display: 'flex',
                                flexGrow: 1,
                                flexWrap: "nowrap",
                            }
                        },
                        option : (base) => {
                            return {
                                ...base,
                                textAlign: 'start'
                            }
                        }
                    }}
                    placeholder="Gyms"
                    options={this.props.gyms}
                    value={this.state.selectedGyms}
                    isMulti={true}
                    onChange={(selectedGyms) => {
                        this.setState({
                            selectedGyms : selectedGyms
                        })
                        this.props.onGymListChange(selectedGyms);
                    }}/>
                <div style={{width:24, height:24}}>
                {!this.props.hideRemove &&
                    <img
                        src={require("assets/images/cancel.svg")}
                        alt={"remove"}
                        onClick={ ()=>this.props.onRemove(this.props.index)}/>
                }
                </div>
            </div>
        )
    }
}

export default AddForm;